// src/pages/LeaderboardPage.tsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Leaderboard from '../components/LeaderboardPage.tsx'; // With extension
import { useGame } from '../context/GameContext';

import { ArrowLeft, Trophy, Shield, Cloud, Network, Lock } from '../components/icons';


const LeaderboardPage: React.FC = () => {
  const { state } = useGame();
  const navigate = useNavigate();
  const [filter, setFilter] = useState<'all' | 'FIREWALL' | 'AZURE' | 'NETWORK' | 'PENTESTER'>('all');

  return (
    <div className="min-h-screen bg-gray-900 py-8 px-4">
      <div className="container mx-auto">
        <div className="flex items-center mb-6">
          <button
            onClick={() => navigate(-1)} // Go back to previous page
            className="mr-4 p-2 rounded-full bg-gray-800 hover:bg-gray-700 transition-colors"
          >
            <ArrowLeft className="h-5 w-5" />
          </button>
          <h1 className="text-2xl font-bold flex items-center">
            <Trophy className="mr-2 text-yellow-400" />
            Layer Defender Leaderboard
          </h1>
        </div>
        
        <div className="bg-gray-800 rounded-lg p-6 shadow-lg mb-8">
          <div className="flex flex-col sm:flex-row justify-between items-center mb-6">
            <p className="text-gray-300 mb-4 sm:mb-0">
              View top players across all classes and track your ranking in the Layer Defender.
            </p>
            
            <div className="flex flex-wrap gap-2 justify-center">
              <button 
                onClick={() => setFilter('all')}
                className={`px-3 py-1 rounded-md ${filter === 'all' ? 'bg-gray-600' : 'bg-gray-700 hover:bg-gray-600'}`}
              >
                All Classes
              </button>
              <button 
                onClick={() => setFilter('FIREWALL')}
                className={`px-3 py-1 rounded-md flex items-center ${filter === 'FIREWALL' ? 'bg-red-900' : 'bg-gray-700 hover:bg-gray-600'}`}
              >
                <Shield className="h-4 w-4 mr-1 text-red-400" /> Firewall
              </button>
              <button 
                onClick={() => setFilter('AZURE')}
                className={`px-3 py-1 rounded-md flex items-center ${filter === 'AZURE' ? 'bg-blue-900' : 'bg-gray-700 hover:bg-gray-600'}`}
              >
                <Cloud className="h-4 w-4 mr-1 text-blue-400" /> Azure
              </button>
              <button 
                onClick={() => setFilter('NETWORK')}
                className={`px-3 py-1 rounded-md flex items-center ${filter === 'NETWORK' ? 'bg-green-900' : 'bg-gray-700 hover:bg-gray-600'}`}
              >
                <Network className="h-4 w-4 mr-1 text-green-400" /> Network
              </button>
              <button 
                onClick={() => setFilter('PENTESTER')}
                className={`px-3 py-1 rounded-md flex items-center ${filter === 'PENTESTER' ? 'bg-purple-900' : 'bg-gray-700 hover:bg-gray-600'}`}
              >
                <Lock className="h-4 w-4 mr-1 text-purple-400" /> Pentester
              </button>
            </div>
          </div>
          
          {/* Embed the Leaderboard component */}
          <Leaderboard filter={filter} />
          
          <div className="mt-6 bg-gray-700 p-4 rounded-lg">
            <h3 className="font-bold mb-2">How Scoring Works</h3>
            <p className="text-sm text-gray-300">
              Your score is determined by how far you progress in the game and how many threats 
              you eliminate. Each class has unique abilities that can help you achieve higher scores. 
              Experiment with different classes to see which one suits your play style best. Higher 
              levels yield more points, and defeating bosses provides substantial bonuses.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeaderboardPage;